import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AddPaymentSplitRequestBody } from '@/domains/payments/features/paymentModals/modals/AddPaymentSplit/types/AddPaymentSplitRequestBody';

export const addPaymentSplitSlice = createSlice({
  name: 'addPaymentSplitSlice',
  initialState: {},
  reducers: {
    addPaymentSplit(_state, _action: PayloadAction<AddPaymentSplitRequestBody & { claimId: number }>) {},
  },
});

export const { addPaymentSplit } = addPaymentSplitSlice.actions;

export const { reducer: addPaymentSplitReducer, reducerPath: addPaymentSplitReducerPath } = addPaymentSplitSlice;
